import React, { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { useSelector } from 'react-redux';

import AlertModal from "../Commons/AlertModal";
import Global from "../../Global/Global";
import BreadCrumb from "../Commons/BreadCrumb";

import { getNavigations, getCurrentNavigation } from "../../slices/navigationSlice";
import { getAuth } from "../../slices/authSlice";

import { getLabel, getLanguage } from "../../tools/Dictionary";

import { MdMenu, MdAccountCircle, MdArrowRight } from "react-icons/md";
import "./Header.css";

const Header = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Auth = useSelector(getAuth); 
  const ListNavigation = useSelector(getNavigations); 
  const CurrentNavigation = useSelector(getCurrentNavigation);

  //Memo
  const MenuNavigation = useMemo(() => {

    const HomeNav = ListNavigation.find(n => n.code == "Home");

    return ListNavigation.filter(n => n.parentId == HomeNav._id);

  }, [ListNavigation]);


  //Navigate
  const Navigate = useNavigate();

  //State
  const [loading, setLoading] = useState(false);
  const [menu, setMenu] = useState(false);
  const [account, setAccount] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  //Ref
  const accountRef = useRef();
  const accountIconRef = useRef();
  const menuRef = useRef();
  const menuIconRef = useRef();


  useEffect(() =>
  {



    // const handleClick = useCallback((e) =>
    // {


    //   console.log("test", account);
    // }, [account]);

    document.addEventListener('mousedown', handleClick); 

    return () =>
    {
      document.removeEventListener('mousedown', handleClick); 
    }

  }, []);

  const handleClick = (e) =>
  {

    if (!accountRef.current || !accountIconRef.current || !menuRef.current || !menuIconRef.current) return;

    let elementStyle = window.getComputedStyle(accountRef.current);

    if (elementStyle.right == "0px" && !accountRef.current.contains(e.target) && !accountIconRef.current.contains(e.target)){
      setAccount(false);
    }

    elementStyle = window.getComputedStyle(menuRef.current);

    if (elementStyle.left == "0px" && !menuRef.current.contains(e.target) && !menuIconRef.current.contains(e.target))
    {
      setMenu(false);
    }

  };


  if (!CurrentNavigation)
    return null;


  const onClickMenu = (_navigation) => {

    //if (_navigation.isParent || _navigation.isReturn) return;

    setMenu(menu => !menu)

  };

  const onClickAccount = (_navigation) =>
  {

    setAccount(account => !account)

  };



  const onClickDisconnect = () => {

    try{

      setLoading(true);

      localStorage.setItem(Global.apiToken, "");
      localStorage.setItem(Global.apiTokenAI, "");
      window.location.reload()

    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

  };


  return (
    <div className="header_cont">
      <div className="header_cont_row">
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="header_menu_cont">
          <div ref={menuIconRef} className="header_menu_icon page_noselect" title="Navigate" onClick={() => setMenu(menu => !menu)}>
            <MdMenu />
          </div>
          <div ref={menuRef} className="header_menu_list page_noselect" style={{ left: (menu ? "0px" : "-310px"), top: (IsDesktop ? "63px" : "47px") }}>
            {MenuNavigation.map((m, index) => (
              <div key={index}>
                <div className="header_menu_list_parent">
                  <div className="header_menu_list_icon" style={{ color: "#808080" }}>
                    <MdArrowRight />
                  </div>
                  <NavLink to={`${m.url}${CurrentNavigation.urlParams ? `?${new URLSearchParams(CurrentNavigation.urlParams).toString()}`: ''}`} onClick={() => onClickMenu(m)} end >
                    {m.label[getLanguage().code]}
                  </NavLink>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="header_title_cont">
          <div className="header_title_text page_noselect" onClick={() => Navigate("/")}>
            Innovair Solutions
          </div>
          <div className="header_title_version">
            v{Global.appVersion} {Global.appStage}
          </div>
        </div>
        <div className="header_account_cont">
          <div ref={accountIconRef} className="header_account_icon page_noselect" title="Account" onClick={onClickAccount}>
            <MdAccountCircle />
          </div>
          <div ref={accountRef} className={`header_account_menu_cont ${account ? "active" : ""}  page_noselect`} style={{}}>
            <div className="header_account_menu_row">
              <div className="header_account_menu_col_title">
                {getLabel("Header", "Account")}
              </div>
              <div className="header_account_menu_col_name">
                {Auth.User.email}
              </div>
              <div className="header_account_menu_col_name">
                {Auth.User.firstName + " " + Auth.User.lastName}
              </div>
              <div className="header_account_menu_col_name" style={{ color: "#424242", fontWeight: "bold"}}>
                {Auth.User.companyName}
              </div>
              <div className="header_account_menu_col_name" style={{ color: "#black", fontWeight: "bold" }}>
                {"<" + (Auth.User.role.label[getLanguage().code] || Auth.User.role.label["EN"] || "") + ">"}
              </div>
              <div className="header_account_menu_list_cont">
                <div className="header_account_menu_col_setting">
                  <NavLink to={"/setting"} end style={{display: "flex", justifyContent: "center"}}>
                    <input
                      type="button"
                      className="page_button"
                      value={getLabel("Account", "Settings")}
                      style={{ maxWidth: "90%", width: "200px", height: "40px"}}
                      disabled={loading}
                      onClick={() => setAccount(false)}
                    />
                  </NavLink>
                </div>
                <div className="header_account_menu_col_button">
                  <input
                    type="button"
                    className="page_button"
                    value={getLabel("Account", "Sign out")}
                    style={{ maxWidth: "400px", backgroundColor: "grey" }}
                    onClick={(loading) ? undefined : onClickDisconnect}
                    disabled={loading}
                    />
                </div>
              </div>
            </div>
          </div>
        </div>     
      </div>
      {IsDesktop &&
        <BreadCrumb 
        />
      }
    </div>
  );

  // //Desktop
  // if (IsDesktop){

  // }
  // //Mobile
  // else{
  //   return (
  //     <div className="header_cont">
  //       <div className="header_menu_cont">
  //         <MdMenu />
  //       </div>
  //     </div>
  //   );
  // }



}
export default Header;
